import styled from 'styled-components'

export const Heading = styled.h4(({ theme }) => ({
  fontSize: '.875rem',
  marginBottom: '1rem',
  fontWeight: '500',
  color: theme.colors.n09
}))
